import { render, staticRenderFns } from "./DetailInfoPeriod.vue?vue&type=template&id=a23002d6&scoped=true&"
import script from "./DetailInfoPeriod.vue?vue&type=script&lang=js&"
export * from "./DetailInfoPeriod.vue?vue&type=script&lang=js&"
import style0 from "./DetailInfoPeriod.vue?vue&type=style&index=0&id=a23002d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23002d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VForm,VRow})
